export default "__VITE_ASSET__3b6dfa4a__"